import React, { useEffect, useState } from 'react'

import {
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'

import DashboardCard from './DashboardCard'
import { useTranslation } from '@contexts/translation'
import useTableStyles from '@styles/table/table'
import numberWithCommas from '@utils/numberWithCommas'
import PlaceHolder from '@components/common/PlaceHolder'
import { useFetchData } from '@api/fetchData'
import API_URL from '@config/services'
import { useAuth } from '@contexts/auth'
import getTotal from '@utils/getTotal'

export default function Tenants() {
  const { dictionary } = useTranslation()
  const classesTable = useTableStyles()
  const { orgSettings } = useAuth()

  const [tenants, setTenants] = useState([])
  const [total, setTotal] = useState(0)

  const { data, isLoading } = useFetchData(API_URL.TENANTS.GET_TENANTS_LIST())

  useEffect(() => {
    if (data) {
      setTenants(
        data.results
          .sort((a, b) => b.balance - a.balance)
          .filter(supplier => supplier.balance > 0)
      )
      setTotal(getTotal(data.results, 'balance'))
    }
  }, [data])

  return (
    <DashboardCard>
      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <Typography variant="h6" sx={{ pl: 2, pb: 0 }}>
            {dictionary.tenants}
          </Typography>
          <Typography variant="h6" sx={{ pr: 2, pb: 0 }}>
            {numberWithCommas(total, 2, orgSettings?.currency_symbol || '')}
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ height: 300 }}>
          <TableContainer className={classesTable.container}>
            <Table aria-label="revenue_adjustments_table">
              <TableHead>
                <TableRow hover={false}>
                  <TableCell className={classesTable.headerCell}>
                    {dictionary.name}
                  </TableCell>
                  <TableCell className={classesTable.headerCell} align="right">
                    {dictionary.balance}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading && (
                  <TableRow className={classesTable.row}>
                    <TableCell align="center" colSpan={'100%'}>
                      <CircularProgress color="secondary" />
                    </TableCell>
                  </TableRow>
                )}
                {!isLoading && !tenants.length && (
                  <TableRow hover={false} className={classesTable.row}>
                    <TableCell align="center" colSpan={'100%'}>
                      <PlaceHolder
                        src={'/Placeholders/Dashboard_Tenants.png'}
                        width={200}
                        height={200}
                      />
                    </TableCell>
                  </TableRow>
                )}
                {tenants.length > 0 &&
                  tenants.slice(0, 6).map(tenant => (
                    <TableRow key={tenant.id} className={classesTable.row}>
                      <TableCell>{tenant.display}</TableCell>
                      <TableCell align="right">
                        {numberWithCommas(
                          tenant.balance,
                          2,
                          orgSettings?.currency_symbol || ''
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </DashboardCard>
  )
}
